import axios, { AxiosResponse } from 'axios';

import { API_ROOT } from 'containers/App/constants';
import api from 'utils/api';
import { getBase64 } from 'utils/prepareFormData';
import API from 'utils/request';

import { ICreditCardsResponse } from '../types';

const checkPayloadForFile = async (body, headers) => {
  if (body.image.file && body.image.file instanceof File) {
    const base64Image = await getBase64(body.image.file);
    const images = [
      {
        file: base64Image,
        filename: body.image.file.name
      }
    ];
    delete body.image;
    return { ...body, images };
  }
  return body;
};

export const getCreditCards = async (params, headers): Promise<ICreditCardsResponse> => {
  const res = await API({
    url: `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/cards`,
    params: params,
    headers: headers
  });
  return res.data;
};

export const changeCreditCardOrder = async (recordA, sort_order: number = 1) => {
  if (sort_order < 1) {
    return Promise.reject('Ordering cannot be less than 1');
  }
  return await API.patch('/v4/dash/custom/bdo/transfer_requests/cards/sort', {
    cards: [
      {
        id: recordA.id,
        sort_order: sort_order
      }
    ]
  });
};

export const createCreditCard = async (body, headers) => {
  body = await checkPayloadForFile(body, 'image');
  return axios
    .post(`${API_ROOT}/v4/dash/custom/bdo/transfer_requests/cards`, body, {
      headers
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getCreditCardApi = (id: number, headers): Promise<AxiosResponse<any>> => {
  return api({
    url: `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/cards/${id}`,
    headers: headers
  });
};

export const updateCreditCard = async (body, params, headers) => {
  body = await checkPayloadForFile(body, 'image');
  return axios
    .put(
      `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/cards/${params.id}`,
      { card: body },
      {
        headers
      }
    )
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const deleteCreditCardApi = (id: number, headers): Promise<AxiosResponse<any>> => {
  return axios
    .delete(`${API_ROOT}/v4/dash/custom/bdo/transfer_requests/cards/${id}`, { headers })
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error.response;
    });
};
